(() => {
  if (!customElements.get('cool-room-slider')) {
    class CoolRoomSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cr-track]');
        this.previousButton = this.querySelector('[data-cr-previous]');
        this.nextButton = this.querySelector('[data-cr-next]');

        if (!this.track) return;

        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      move(direction) {
        const firstItem = this.track.querySelector(':scope > *');
        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const distance = (firstItem?.getBoundingClientRect().width || this.track.clientWidth * 0.82) + gap;

        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      update() {
        const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
        const progress = maxScroll === 0 ? 100 : 20 + (this.track.scrollLeft / maxScroll) * 80;
        this.style.setProperty('--cr-progress', `${Math.min(Math.max(progress, 20), 100)}%`);

        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }

    customElements.define('cool-room-slider', CoolRoomSlider);
  }

  const initializeVideos = (scope = document) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('[data-cr-video-toggle]:not([data-cr-ready])').forEach((button) => {
      const card = button.closest('[data-cr-video-card]');
      const video = card?.querySelector('video');
      if (!video) return;

      button.setAttribute('data-cr-ready', 'true');

      if (reduceMotion) {
        video.pause();
        button.setAttribute('aria-label', '動画を再生');
        button.textContent = '▶';
      }

      button.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
          button.setAttribute('aria-label', '動画を一時停止');
          button.textContent = 'Ⅱ';
        } else {
          video.pause();
          button.setAttribute('aria-label', '動画を再生');
          button.textContent = '▶';
        }
      });
    });
  };

  initializeVideos();
  document.addEventListener('shopify:section:load', (event) => initializeVideos(event.target));
})();
